import { render } from "./MultiSelectDropdown.vue?vue&type=template&id=4134d958&scoped=true"
import script from "./MultiSelectDropdown.vue?vue&type=script&lang=js"
export * from "./MultiSelectDropdown.vue?vue&type=script&lang=js"

import "./MultiSelectDropdown.vue?vue&type=style&index=0&id=4134d958&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4134d958"]])

export default __exports__